"use client";

import { usePathname } from "next/navigation";

export function useNavActive() {
  const pathname = usePathname();

  return (href?: string) => {
    if (!href) return false;
    if (!pathname) return false;
    return pathname === href || pathname.startsWith(`${href}/`);
  };
}
